// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  header: {
    height: 70,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingLeft: 100,
    [theme.breakpoints.down(1200)]: {
      paddingLeft: 50,
      paddingRight: 10,
    },
    [theme.breakpoints.down(800)]: {
      paddingLeft: 10,
    },
    [theme.breakpoints.down(500)]: {
      paddingRight: 5,
      height: 'fit-content',
      alignItems: 'flex-start',
    },
  },
  menuIconContainer: {
    padding: 5,
    marginRight: 20,
    [theme.breakpoints.down(550)]: {
      marginRight: 10,
    },
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    marginTop: 5,
    '&:hover': {
      textDecoration: 'none',
    },
  },
  logoImage: {
    height: 60,
    [theme.breakpoints.down(370)]: {
      height: 50,
    },
    [theme.breakpoints.down(340)]: {
      height: 40,
    },
  },
  menuContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down(500)]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-end',
    },
  },
  menuLeft: {
    marginRight: 40,
    marginTop: 15,
  },
  menuTextLeft: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 5px',
    padding: 5,
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_SECONDARY,
    },
  },
  buttonStyle: {
    marginRight: 30,
    [theme.breakpoints.down(1200)]: {
      marginRight: 20,
    },
    [theme.breakpoints.down(1150)]: {
      marginRight: 100,
    },
    [theme.breakpoints.down(700)]: {
      marginRight: 0,
    },
    [theme.breakpoints.down(550)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
      padding: '6px 9px',
    },
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 35,
    height: 35,
  },
  counterContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: GlobalStyles.color.COLOR_PRIMARY,
    marginLeft: 10,
    marginTop: -10,
  },
  isNotAll: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
  },
  isAll: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  counter: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: 10,
    paddingTop: 1,
  },
  image: {
    width: 26,
    height: 26,
  },
  flexDirectionColumn: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menuRightIndex: {
    marginRight: 150,
    marginLeft: 90,
    [theme.breakpoints.down(1500)]: {
      marginRight: 30,
      marginLeft: 20,
    },
    [theme.breakpoints.down(1200)]: {
      marginRight: 0,
      marginLeft: 40,
    },
    [theme.breakpoints.down(550)]: {
      marginLeft: 10,
    },
    [theme.breakpoints.down(400)]: {
      marginLeft: 0,
    },
  },
  menuRight: {
    marginLeft: 40,
    [theme.breakpoints.down(550)]: {
      marginLeft: 10,
    },
    [theme.breakpoints.down(400)]: {
      marginLeft: 0,
    },
  },
  menuTextRight: {
    display: 'flex',
    whiteSpace: 'nowrap',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    [theme.breakpoints.down(1200)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_PRIMARY,
    },
  },
  menuContainerRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  blueColor: {
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
});

export default styles;
